var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.087 17.5443H3.50061C2.11986 17.5443 1.00054 16.425 1.00056 15.0443L1.00065 5.53957C1.00066 4.58755 1.0003 3.23155 1 2.24971C0.999787 1.55915 1.55952 1 2.25008 1H8.20667L11.087 4.07677H19.75C20.4403 4.07677 21 4.63642 21 5.32679V8.64725M19.125 16.1474L20.375 17.3974M19.75 13.6474C19.75 15.3733 18.3508 16.7724 16.6249 16.7724C14.899 16.7724 13.4998 15.3733 13.4998 13.6474C13.4998 11.9214 14.899 10.5223 16.6249 10.5223C18.3508 10.5223 19.75 11.9214 19.75 13.6474Z",
    stroke: "#825DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0dcfc2d696857842e742aac1cca7b635.svg";
export { ForwardRef as ReactComponent };